import { usePageTopBar } from '@/app/layouts/pageTopBar';
import type { ArTab } from '../types';
import { InsuranceAr } from '../InsuranceAr';

export function InsuranceArPage({ view = 'waiting' }: { view?: ArTab }) {
  usePageTopBar({ breadcrumb: ['Insurance A/R'] });
  return <InsuranceAr view={view} />;
}
